interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '多线路智能调度，自动匹配最优CDN节点，1080P超清画质下也能流畅播放不卡顿。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台适配',
    desc: '无需下载App，手机浏览器直接访问。iOS、Android、平板全设备自动适配最佳观影布局。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '紧跟各大平台播出节奏，热门剧集综艺上线即同步，追剧党永远快人一步。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '全站无弹窗广告侵扰，专注纯粹观影体验。不收集用户隐私，无需注册即可观看。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            为什么选我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            用心打造每一处细节，只为更好的观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={feat.title}
              className="group bg-background-100 rounded-2xl p-6 md:p-7 border border-background-200/80 hover:border-primary-200 transition-all duration-300 text-center"
            >
              <div
                className={`w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-2xl mb-5 transition-colors ${
                  i === 0
                    ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                    : i === 1
                    ? 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
                    : i === 2
                    ? 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50'
                    : 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                }`}
              >
                <i className={`${feat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}